import { CalendarDate } from '@internationalized/date';
import { useAtom } from 'jotai/index';
import { useEffect } from 'react';

import DatePickerMode from '../../../../../../types/DatePickerMode';
import datePickerModeAtLoadAtom from '../../../../../atoms/datePickerModeAtLoadAtom';
import RequestedDates from '../../../types/RequestedDates';
import determineMode from '../helpers/determineMode';

type Options = {
    serverSideDatePickerMode: DatePickerMode;
    onChange?: (dates: RequestedDates) => void;
    currentPickupDate?: CalendarDate;
};

const useDatePickerMode = ({
    serverSideDatePickerMode,
    onChange,
    currentPickupDate,
}: Options) => {
    const [datePickerMode, setDatePickerMode] = useAtom(
        datePickerModeAtLoadAtom
    );

    const changeDatePickerMode = (newMode: DatePickerMode) => {
        setDatePickerMode(newMode);

        if (!currentPickupDate) {
            return;
        }

        onChange?.({
            pickupDate: currentPickupDate,
            returnDate: currentPickupDate,
        });
    };

    const determinedMode = determineMode(
        datePickerMode,
        serverSideDatePickerMode
    );

    useEffect(() => {
        if (determinedMode.datePickerMode === 'OnlyMultiDay') {
            setDatePickerMode('PrimarilyMultiDay');
        }

        if (determinedMode.datePickerMode === 'OnlySingleDay') {
            setDatePickerMode('OnlySingleDay');
        }
    }, [determinedMode.allowSwitch, determinedMode.datePickerMode]);

    return {
        datePickerMode: determinedMode.datePickerMode,
        allowSwitch: determinedMode.allowSwitch,
        changeDatePickerMode: changeDatePickerMode,
    };
};

export default useDatePickerMode;
